<template>
  <div :class="$style.wrapper">
    <div ref="gameCatalogue" :class="$style.containerBlock">
      <MainPageCatalogue :page-type="pageType" />
      <MainPageWinnersNowSlider
        gtm-category="winners"
        gtm-action="winners_click"
        variant="table"
        :number-of-winners="8"
      />
      <MainPageSeoText
        :text="pageSeoDescription.text"
        :hidden-text="pageSeoDescription.hiddenText"
        :show-more="pageSeoDescription.showMore"
        :show-less="pageSeoDescription.showLess"
        :auto-link-parse="pageSeoDescription.autoLinksParse"
      />
    </div>
    <Breadcrumbs v-if="breadcrumbsBlock" :breadcrumbs-list="breadcrumbsBlock" />
  </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeMount, ref } from 'vue';
import { Breadcrumbs, MainPageSeoText } from '~/components/lib/mainPage';
import MainPageCatalogue from '~/components/mainPage/catalogue.vue';
import MainPageWinnersNowSlider from '~/components/mainPage/winnersNowSlider.vue';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import { useStoreCataloguePage } from '~/stores/strapi/cataloguePage';
import { useStoreProviders } from '~/stores/strapi/providers';

const props = defineProps({
  pageId: {
    type: String,
    required: true,
    default: '',
  },
  pageType: {
    type: String,
    required: false,
    default: () => '',
  },
  currentInfoPage: {
    type: Object,
    default: () => null,
  },
});

const storeCataloguePage = useStoreCataloguePage();
const storeButtonsTitle = useStoreButtonTitles();

const gameCatalogue = ref(null);

/**
 * Getter that returns SEO description
 */
const pageSeoDescription = computed(
  (): {
    text: string;
    hiddenText: string;
    showMore: string;
    showLess: string;
    autoLinksParse: boolean;
  } => {
    return {
      text: props.currentInfoPage?.descriptionText || '',
      hiddenText: props.currentInfoPage?.descriptionHiddenText || '',
      showMore: storeButtonsTitle.showMoreGames || '',
      showLess: storeButtonsTitle.showLessGames || '',
      autoLinksParse: !!props.currentInfoPage?.autoLinkFormat,
    };
  }
);

/**
 * Getter that returns breadcrums block if exists
 */
const breadcrumbsBlock = computed(() => props.currentInfoPage?.breadcrumbs || null);

onBeforeMount(() => {
  if (useStoreProviders().list.some(({ providerId }) => providerId === props.pageId)) {
    storeCataloguePage.setProvider(props.pageId);
  } else {
    storeCataloguePage.setCollection(props.pageId);
  }
});
</script>

<style lang="scss" module src="./cataloguePage.scss"></style>
